export default __webpack_public_path__ + "static/fix-image-d352dbd41bcd043e7a1946c47cff5f46.png";